import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const LogOutIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <line
        data-cap="butt"
        data-color="color-2"
        x1={10}
        y1={16}
        x2={28}
        y2={16}
        fill="none"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <polyline
        data-color="color-2"
        points="21 23 28 16 21 9"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <path
        d="M25,6V4a3,3,0,0,0-3-3H8A3,3,0,0,0,5,4V28a3,3,0,0,0,3,3H22a3,3,0,0,0,3-3V26"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
    </svg>
  );
};
